import { FC, memo } from "react";
import { Stack } from "@mui/material";
import { BillingExplorerWidgetContentCosts } from "../BillingExplorerWidgetContentCosts";
import { BillingExplorerWidgetHighChart } from "../../../../adding-widget/widget-create/widget-setups/billing-explorer/components/high-chart-view/BillingExplorerWidgetHighChart";
import { useAppSelector } from "@/store/hooks";
import { DateLabelNullable } from "@/services/cloudchipr.api";
import { billingExplorerWidgetHasAggregationSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetHasAggregationSelector";
import { billingExplorerWidgetByIdSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetByIdSelector";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { billingExplorerSetupPropertyByKeySelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupPropertyByKeySelector";
import { billingExplorerWidgetFrequencySelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetFrequencySelector";
import { billingExplorerWidgetDataByWidgetIdSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetDataByWidgetIdSelector";

interface BillingExplorerWidgetChartViewProps {
  widgetId: string;
  dateLabel?: DateLabelNullable;
}

export const BillingExplorerWidgetChartView: FC<BillingExplorerWidgetChartViewProps> =
  memo(({ widgetId, dateLabel }) => {
    const hasAggregations = useAppSelector((state) =>
      billingExplorerWidgetHasAggregationSelector(state, widgetId),
    );

    const widget = useAppSelector((state) =>
      billingExplorerWidgetByIdSelector(state, widgetId),
    );
    const dates = widget?.dates;

    const quarterStartMonth = useAppSelector(
      organisationQuarterStartMonthSelector,
    );
    const data = useAppSelector((state) =>
      billingExplorerWidgetDataByWidgetIdSelector(state, widgetId),
    );

    const chartData = data?.data;
    const forecastedCosts = data?.forecasted_costs;

    const loading = useAppSelector(
      billingExplorerSetupPropertyByKeySelector("loading"),
    );

    const frequency = useAppSelector((state) =>
      billingExplorerWidgetFrequencySelector(state, widgetId),
    );

    if (!widget?.visualization) {
      return;
    }

    return (
      <Stack
        px={2}
        py={1}
        gap={1}
        flex={1}
        justifyContent={hasAggregations ? "start" : "center"}
      >
        <BillingExplorerWidgetContentCosts
          widgetId={widgetId}
          dateLabel={dateLabel}
        />

        <BillingExplorerWidgetHighChart
          dates={dates}
          data={chartData}
          loading={loading}
          frequency={frequency}
          hasAggregations={hasAggregations}
          forecastedCosts={forecastedCosts}
          visualization={widget.visualization}
          quarterStartMonth={quarterStartMonth}
        />
      </Stack>
    );
  });
